import { useEffect } from "react"
import { useTheme } from "@/lib/theme"
import lockupUrl from "./keel-lockup.svg"
import lockupReverseUrl from "./keel-lockup-reverse.svg"
import markUrl from "./keel-mark.svg"
import markReverseUrl from "./keel-mark-reverse.svg"

/**
 * Keel logos, from the client's design-system files (keel-lockup.svg, keel-mark.svg), drawn as
 * images so the artwork is never retyped, recoloured or restyled. Abyss ink on white only: no
 * rounded corners, outlines, gradients or shadows, and the brass line always stays. The files'
 * viewBoxes already include the clear space (one K-stem width) on every side. In the dark theme the
 * reverse files are used: the same artwork with the ink knocked out to near-white (brass unchanged).
 */

/** KEEL wordmark on the brass bar. Never narrower than 72px. */
export function KeelLockup({ width = 112, className }: { width?: number; className?: string }) {
  const w = Math.max(72, width)
  const dark = useTheme().resolved === "dark"
  return <img src={dark ? lockupReverseUrl : lockupUrl} alt="Keel" width={w} height={Math.round((w * 100) / 266)} className={className} draggable={false} />
}

/** K on the brass bar. Never smaller than 16px. */
export function KeelMark({ size = 32, className, label = "Keel" }: { size?: number; className?: string; label?: string }) {
  const s = Math.max(16, size)
  const dark = useTheme().resolved === "dark"
  return <img src={dark ? markReverseUrl : markUrl} alt={label} width={s} height={s} className={className} draggable={false} />
}

/** Browser tab title: "Keel" on its own, "Page · Keel" for a page. */
export function usePageTitle(page?: string | null) {
  useEffect(() => {
    document.title = page ? `${page} · Keel` : "Keel"
  }, [page])
}
